import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import {Link} from 'react-router-dom';
import firebase from 'firebase';
import store from '../../store';

const database=firebase.database();

class SociosGanancias extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
			socios:[],
			sociostemp:[],
			labels:['Nombre','Apellido','Estado','Correo']
	
		}
		
		this.sociosRef=database.ref().child('Socios');
		this.handleChangeEstado=this.handleChangeEstado.bind(this);
		this.handleClickPrint=this.handleClickPrint.bind(this);
		this.changeStatePrint=this.changeStatePrint.bind(this);
		this.mostrarTodos=this.mostrarTodos.bind(this);
		
	}
	
	
	componentDidMount(){
		
		this.sociosRef.on('value',this.gotDataSocios,this.errDataSocios);
		
	}
	
	componentWillMount(){
		
		
		
	}
	
	gotDataSocios=(data)=>{
			
		let newSocios=[];
		
		if(data.val()!==null){
			
			let socio=data.val();
			let keys=Object.keys(socio);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
						
				if(socio[k].Nombre!==undefined){
					
					newSocios.push({
						key:k,
						nombre:socio[k].Nombre,
						apellido:socio[k].Apellido,
						estado:socio[k].Estado,
						correo:socio[k].correo
					})
				}
				
			}
			this.setState({
				socios:newSocios,
				sociostemp:newSocios
			});			
		}		
	}
	errDataSocios=(err)=>{
		
		console.log(err);
		
	}
	
	handleChangeEstado(){
		
		let newSocios=[]
		
		let estado=this.estado.value;
		
		this.state.socios=this.state.sociostemp
		this.setState({
			
			socios:this.state.sociostemp
			
		})
		
		for(let i=0;i<this.state.socios.length;i++){
			
			let estado_socios=(this.state.socios[i].estado.toLowerCase()===(estado.toLowerCase()))?true:false;
			
			
			if(estado_socios){
				
				newSocios.push({
					
						key:this.state.socios[i].key,
						nombre:this.state.socios[i].nombre,
						apellido:this.state.socios[i].apellido,
						estado:this.state.socios[i].estado,
						correo:this.state.socios[i].correo
					
					
				})
				
				
			}
		
		}
		this.state.socios=newSocios
		this.setState({
			
			socios:newSocios
			
		})
		
		
		
	}
	
	
	mostrarTodos(){
		
		
		this.setState({
			
			socios:this.state.sociostemp
			
		})
		
	}
	
	handleClickPrint(){
		
		this.changeStatePrint();
		
	}
	
	changeStatePrint(){
		
		store.dispatch({
			
			type: "STATE_REPORT",
			labels_report:this.state.labels,
			data_report:this.state.socios,
			tipo_reporte:'reporte_socios'
		})
			
	}
	
	
	render(){
		
		return(
		
				<div className="reporte_ganancias_socios">
	
					<div className="row">
						<div className="col-md-4">
							<Link to="template" className="btn btn-success" onClick={this.handleClickPrint}><span className="glyphicon glyphicon-print"> Imprimir</span></Link>
						</div>
						<div className="col-md-4">
							<div className="form-group">
								<label htmlFor="estado">Estado</label>
								<select ref={input=>{this.estado=input}}
								onChange={this.handleChangeEstado}
								className="form-control"
								>
									<option value="Activo">Activo</option>
									<option value="Inactivo">Inactivo</option>
								</select>
							</div>
						</div>
						<div className="col-md-4">
							<br/>
							<button type="button" className="btn btn-primary" onClick={this.mostrarTodos}>Mostrar todos</button>
						</div>
							
					</div>


	
					<BootstrapTable data={ this.state.socios }
							 ref='table'			 
							 pagination={ true }
							 search={ false }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre'  dataSort={true}  >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='apellido' >Apellido</TableHeaderColumn>
							 <TableHeaderColumn dataField='estado' >Estado</TableHeaderColumn>
							 <TableHeaderColumn dataField='correo' >Correo</TableHeaderColumn>
							 	
					</BootstrapTable>
						
				
				</div>
		
		)
		
		
	}
	
	
}


export default SociosGanancias;


// WEBPACK FOOTER //
// ./src/Components/Reportes/SociosGanancias.jsx